function xMileEnc(value) {
	var enc = CryptoJS.AES.encrypt(value, 'xC8Y99rVye8JgfbqDGNZGWBM').toString();
	var encUtf = CryptoJS.enc.Utf8.parse(enc);
	var encBase64 = CryptoJS.enc.Base64.stringify(encUtf);
	return xMileCleanURLEncoded(encBase64);
}

function xMileCleanURLEncoded(value) {
    var idx = value.indexOf('=');
    var result = value;
	if (idx > 0) {
	  result = value.substring(0, idx);
	}

    result = result.replace("=", "");
    result = result.replace("%3D", "");
    result = result.replace("%253D", "");

    return result;
}